<template>
<main>
  <div class="mx-auto max-w-5xl space-y-4">
    <section class="rounded-2xl border border-slate-200 bg-white px-3 pt-3 pb-2 shadow-sm sm:px-4">
      <div class="space-y-2">
        <h2 class="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl">Wristband search</h2>
        <p class="text-sm text-slate-500">Find a delegate by wristband code.</p>
      </div>

      <form @submit.prevent="searchRegistrations" class="mt-3 flex flex-col gap-2 sm:flex-row">
        <div class="flex flex-1 items-stretch gap-2">
          <label class="block flex-1">
            <span class="sr-only">Search wristband</span>
            <input
              ref="searchInput"
              v-model="filterText"
              type="text"
              placeholder="Enter wristband code"
              class="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-sm text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-slate-200 focus:bg-white"
              aria-label="Search wristband"
            />
          </label>
          <button
            type="submit"
            class="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50"
            aria-label="Search"
            title="Search"
          >
            <MagnifyingGlassIcon class="h-5 w-5" />
          </button>
          <button
            type="button"
            class="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-400"
            @click="clearFilter"
            aria-label="Clear search"
            title="Clear search"
            :disabled="!filterText"
          >
            <XMarkIcon class="h-5 w-5" />
          </button>
        </div>
      </form>
    </section>
  </div>
</main>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/20/solid'

export default defineComponent({
  components: {
    MagnifyingGlassIcon,
    XMarkIcon
  },
  setup () {
    const router = useRouter()
    const filterText = ref('')
    const searchInput = ref(null)

    const searchRegistrations = async () => {
      if (!filterText.value.trim()) return
      router.push('/registration-ticket/wristband/' + filterText.value)
    }

    const clearFilter = async () => {
      filterText.value = ''
      if (searchInput.value) {
        searchInput.value.focus()
      }
    }

    return {
      searchRegistrations,
      filterText,
      clearFilter,
      searchInput
    }
  }
})
</script>
